/**
 * Extracts the country code from the locale set on the window object.
 *
 * For India (.in domain), always returns 'IN'.
 * Otherwise, uses the COUNTRY_CODE_FROM_LOCALE global variable if available.
 *
 * @returns The uppercase country code (e.g., 'US', 'IN') or undefined if not available
 */
export const getCountryCodeFromLocale = () => {
  const isInIndia = window.location.host.indexOf('hubspot.in') > -1;
  if (isInIndia) {
    return 'IN';
  }
  const countryCodeFromLocale = window.COUNTRY_CODE_FROM_LOCALE;
  return countryCodeFromLocale === null || countryCodeFromLocale === void 0 ? void 0 : countryCodeFromLocale.toUpperCase();
};